import React, { useState, useContext, useEffect } from 'react';
import DogRegister from "../assets/svg/DogRegister.svg"
import Background from "../assets/svg/Home.svg"
import RegisterBackground from "../assets/svg/Register.svg"


export default function Position() {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-zinc-900 to-zinc-800 text-white px-4 bg-cover" style={{ backgroundImage: `url(${Background})` }} >
            <div className="w-full max-w-xl text-center">
                <h1 className="text-4xl md:text-5xl font-bold mb-8 ">
                    Installing Updates <br /><span className='text-2xl'>Please Check Back Soon</span>
                </h1>

                {/* Progress Bar */}
                <div className="w-full bg-zinc-700 rounded-full h-6 overflow-hidden shadow-inner shim-green">
                    <div className="bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 h-full animate-progressBar"></div>
                </div>
            </div>
        </div>

    );
}